<template>
	<div class="chatClass">
		<div class="logo" style="">
			<img src="@/image/logo02.png" alt="Logo" class="project-logo" />
			岚医全域医疗智能体
		</div>
		<div class="search">
			<el-input placeholder="搜索患者姓名或者住院号" v-model="searchStr" clearable>
				<i slot="prefix" class="el-input__icon el-icon-search"></i>
			</el-input>
		</div>
		<div class="statusBox">
			<el-tooltip class="item" :open-delay=800 effect="dark" content="Top Left 提示文字" placement="top"
				v-for="(item,index) in statusList" :key="item.id">
				<div :key="index" :class="['statusItem',activeStatus==item.name?'activeStatus':'']"
					@click="statusBtn(item)">{{item.name}}({{getStatusCount(item.name)}})
				</div>
			</el-tooltip>
		</div>
		<div class="statusBox2">
			<div class="left" v-if="false">
				<el-tooltip class="item" :open-delay=800 effect="dark" content="叫下一位患者" placement="top">
					<div class="btn">下一位</div>
				</el-tooltip>
				<el-tooltip class="item" :open-delay=800 effect="dark" content="叫本次号并预加裁患者信息" placement="top"
					style="display: none;">
					<div class="btn">叫号</div>
				</el-tooltip>
				<el-tooltip class="item" :open-delay=800 effect="dark" content="过号此患者" placement="top">
					<div class="btn">过号</div>
				</el-tooltip>
			</div>
			<div class="right">
				<el-checkbox v-model="queryByDepartment" @change="handleDeptScopeChange">本科室</el-checkbox>
				<select data-v-0f08815f class="select" v-model="selectedSortField" @change="applySorting">
					<option value="default" data-v-0f08815f>默认排序</option>
					<option value="checkInTime" data-v-0f08815f>报到时间</option>
					<option value="name" data-v-0f08815f>姓名</option>
					<option value="visitNumber" data-v-0f08815f>患者编号</option>
					<option value="gender" data-v-0f08815f>性别</option>
					<option value="age" data-v-0f08815f>年龄</option>
				</select>
				<el-tooltip class="item" :open-delay=800 effect="dark" content="切换排序方式" placement="top">
					<button @click="toggleSortOrder">
						<i class="el-icon-arrow-up" v-if="isAscending"></i>
						<i class="el-icon-arrow-down" v-else></i>

					</button>
				</el-tooltip>
				<el-tooltip class="item" :open-delay=800 effect="dark" content="简化显示" placement="top">
					<button @click="is_simpleBtn" class="icon-btn">
						<i class="el-icon-full-screen"></i>
					</button>
				</el-tooltip>
				<el-tooltip class="item" :open-delay=800 effect="dark" content="刷新患者列表" placement="top">
					<button @click="refreshData">
						<i class="el-icon-refresh"></i>
					</button>
				</el-tooltip>
				<!-- 临时测试按钮：创建患者 -->
				<el-tooltip class="item" :open-delay=800 effect="dark" content="创建患者（测试用）" placement="top">
					<button @click="showAddPatientDialog"
						style="margin-left: 8px; padding: 4px 8px; background: #409eff; color: white; border: none; border-radius: 4px; cursor: pointer;">
						<i class="el-icon-plus"></i>
					</button>
				</el-tooltip>
			</div>
		</div>

		<!-- 创建患者弹窗（临时测试用） -->
		<el-dialog title="添加患者" :visible.sync="addPatientDialogVisible" width="400px" :close-on-click-modal="false"
			:append-to-body="true" :modal="false" @close="resetAddPatientForm">
			<el-form ref="addPatientForm" :model="addPatientForm" :rules="addPatientFormRules" label-width="80px">
				<el-form-item label="姓名" prop="realname">
					<el-input v-model="addPatientForm.realname" placeholder="请输入姓名" maxlength="10" clearable
						show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="性别" prop="sex">
					<el-radio-group v-model="addPatientForm.sex">
						<el-radio :label="1">男</el-radio>
						<el-radio :label="2">女</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="年龄" prop="age">
					<el-input v-model="addPatientForm.age" placeholder="请输入年龄" maxlength="3" type="number" clearable></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="phone">
					<el-input v-model="addPatientForm.phone" placeholder="请输入手机号" maxlength="11" type="tel" clearable
						req></el-input>
				</el-form-item>
				<el-form-item label="所属病房" prop="departmentId">
					<el-select v-model="addPatientForm.departmentId" placeholder="选择科室" style="width: 100%;" clearable>
					<el-option v-for="dept in patientDepartmentList" :key="dept.id" :label="dept.departmentName"
						:value="dept.id"></el-option>
				</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addPatientDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="handleAddPatient" :loading="addPatientLoading">保存</el-button>
			</div>
		</el-dialog>

		<div class="list">
			<template v-for="(item, index) in displayClassData">
				<div :class="[
            'itemBox',
            active === item.id ? 'active' : '',
            getPatientStatus(item) === 'called' ? 'calledPatient' : '',
            getPatientStatus(item) === 'passed' ? 'passedPatient' : '',
            expandedCards[item.id] ? 'yjhShow' : ''
          ]" :key="index" @click="itemBtn(item, index, $event)">
					<div class="item">
						<div class="info">
							<div class="name">{{item.realname || '未知患者'}}</div>
							<div class="qt">
								<div :class="['tag',item.visitStatus==1?'blue':item.visitStatus==2?'green':'blue']">
									{{item.visitStatusText || (item.visitStatus==1?'未完成':item.visitStatus==2?'已完成':'-')}}
								</div>
								<div class="tag blue">{{item.age ? item.age + '岁' : '  '}}
									{{item.sexText || (item.sex==1?'男':'女')}}
								</div>
							</div>
						</div>
						<!-- 用户名和症状显示，受简化显示控制 -->
						<div v-if="!is_simple" class="number">{{item.visitNum || ''}}</div>
						<div v-if="!is_simple" class="number">{{item.chatSummary || '暂无预问诊记录'}}</div>

						<!-- 全部展开/收起按钮，只在当前卡片展开时显示 -->
						<div v-if="expandedCards[item.id]" class="expandBox">
							<el-tooltip class="item" :open-delay=800 effect="dark"
								:content="allExpanded[item.id] ? '收起所有病历记录和检验报告' : '展开所有病历记录和检验报告'" placement="top">
								<div class="btn" @click.stop="toggleAllExpanded(item.id)">
									<i :class="allExpanded[item.id] ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
									{{allExpanded[item.id] ? '全部收起' : '全部展开'}}
								</div>
							</el-tooltip>
						</div>
					</div>
					<!-- 详细信息卡片，只在当前卡片展开时显示 -->
					<div v-if="expandedCards[item.id]" class="card">
						<div class="cardItem">
							<div class="title">
								病历记录
								<el-tooltip class="item" :open-delay=800 effect="dark" content="刷新病历记录" placement="top">
									<div @click.stop="refreshMedicalRecords(item.id, item.username)"
										style="height:1rem;width:1rem;padding:0;">
										<i class="el-icon-refresh"></i>
									</div>
								</el-tooltip>
							</div>
							<div class="medical-records-container">
								<el-collapse :value="getActiveCollapseNames(item.id, 'medical')"
									@change="handleCollapseChange($event, item.id, 'medical')">
									<el-collapse-item v-for="(record, index) in getMedicalRecordsFromCache(item.id)"
										:key="record.id" :name="record.id">
										<template #title>
											<div class="collapseTle" @click.stop="emitViewMedicalDetail(record.id)">
												<div class="data">{{record.date}}</div>
												<div class="illness">{{record.diagnosis}}</div>
											</div>
										</template>
										<div class="content">
											<div class="font">主诉</div>
											<div class="text">{{record.complaint}}</div>
											<div class="font">体格检查</div>
											<div class="text">{{record.examination}}</div>
											<div class="font">诊断</div>
											<div class="text">{{record.diagnosis}}</div>
											<div class="font">治疗方案</div>
											<div class="text">{{record.treatment}}</div>
										</div>
									</el-collapse-item>
								</el-collapse>
							</div>
						</div>
						<div class="cardItem">
							<div class="title">
								检验报告
								<el-tooltip class="item" :open-delay=800 effect="dark" content="刷新检验报告" placement="top">
									<div @click.stop="refreshTestReports(item.id, item.username, item.departmentId)"
										style="height:1rem;width:1rem;padding:0;">
										<i class="el-icon-refresh"></i>
									</div>

								</el-tooltip>
							</div>
							<div class="test-reports-container">
								<el-collapse :value="getActiveCollapseNames(item.id, 'test')"
									@change="handleCollapseChange($event, item.id, 'test')">
									<el-collapse-item v-for="(report, index) in getTestReportsFromCache(item.id)"
										:key="report.id" :name="report.id">
										<template #title>
											<div class="collapseTle">
												<div class="illness">{{report.name}} ({{report.date}})</div>
											</div>
										</template>
										<div class="content">
											<div class="img" v-if="report.image"></div>
											<div class="font">检验项目</div>
											<div class="text">{{report.items}}</div>
											<div class="font">检验结果</div>
											<div class="text">{{report.result}}</div>
											<div class="font">参考范围</div>
											<div class="text">{{report.reference}}</div>
											<div class="font">检验总结</div>
											<div class="text">{{report.summary}}</div>
										</div>
									</el-collapse-item>
								</el-collapse>
							</div>
						</div>
					</div>
				</div>
			</template>
			<div v-if="displayClassData.length === 0 && !listLoading" style="text-align: center;margin-top: 20px">暂无患者</div>
		</div>
		<div class="patient-pagination" v-if="patientListTotal > 0">
			<el-button
				type="default"
				size="small"
				class="page-btn"
				:disabled="!canPrevPage"
				:loading="listLoading && pageLoadingDirection === 'prev'"
				@click="handlePrevPage"
			>上一页</el-button>
			<span class="page-info">{{ pageStatusText }}</span>
			<el-button
				type="default"
				size="small"
				class="page-btn"
				:disabled="!canNextPage"
				:loading="listLoading && pageLoadingDirection === 'next'"
				@click="handleNextPage"
			>下一页</el-button>
		</div>
	</div>
</template>

<script>
	import {
		request
	} from "@/utils/request";
	import {
		queryDepartmentListApi as queryDepartmentListApi
	} from "@/services/patient/api";

	export default {
		name: "ConsultationControl_class",
		components: {},
		props: {
			classData: {
				type: Array
			},
			currentChatId: {
				type: String,
				default: ''
			},
			// 数据来源："1" 门诊；"2" 住院（住院必须传）
			dataOrigin: {
				type: [String, Number],
				default: ''
			}
		},
		async mounted() {
			await Promise.all([
				this.getPatientSummary(),
				this.loadInitialPatientList(),
				this.loadInitialPatientDepartmentList()
			]);
		},
		watch: {
			searchStr: {
				handler: function(newVal, oldVal) {
					// 手动防抖
					if (this.searchDebounceTimer) {
						clearTimeout(this.searchDebounceTimer);
					}
					this.getPatientSummary();
					this.searchDebounceTimer = setTimeout(async () => {
						await this.loadPatientList({ resetPage: true });
					}, 300);
				},
				immediate: false
			},
			// 监听 props 的 classData 变化，同步到本地数据
			classData: {
				handler: function(newVal) {
					// 当本地数据未初始化时，或接收到新的排序/筛选数据时，使用 props 的数据
					if (this.localPatientList === null || this.localPatientList === undefined) {
						this.localPatientList = newVal || [];
					} else {
						// 如果本地数据已存在，检查是否是来自父组件的更新（通过比较长度或内容）
						// 这里我们总是接受父组件的更新，因为排序、筛选等操作会触发父组件更新
						if (newVal && Array.isArray(newVal)) {
							this.localPatientList = newVal;
						}
					}
				},
				immediate: true
			}
		},
		computed: {
			// 显示的患者列表数据
			// 优先使用本地数据（搜索时更新的），如果没有则使用 props 传入的数据
			// 核心解决方案：在组件内部维护本地患者列表，搜索时直接更新本地数据，
			// 这样就不需要依赖父组件更新 props，避免了数据不同步的问题
			displayClassData() {
				// 如果本地有数据（包括空数组，表示搜索后没有结果），优先使用本地数据
				// 注意：需要判断 localPatientList 是否被初始化过（通过检查是否为 null/undefined）
				// 如果 localPatientList 是空数组，说明已经搜索过但没有结果，应该显示空数组
				// 如果 localPatientList 是 null/undefined，说明还没有搜索过，使用 props 的数据
				if (this.localPatientList !== null && this.localPatientList !== undefined) {
					return this.localPatientList;
				}
				// 否则使用 props 传入的数据
				return this.classData || [];
			},
			totalPages() {
				if (!this.patientListTotal) {
					return 1;
				}
				return Math.ceil(this.patientListTotal / this.pageSize);
			},
			canPrevPage() {
				return this.pageNo > 1 && !this.listLoading;
			},
			canNextPage() {
				return this.pageNo < this.totalPages && !this.listLoading;
			},
			pageStatusText() {
				if (!this.patientListTotal) {
					return '第 0 / 0 页';
				}
				return `第 ${this.pageNo} / ${this.totalPages} 页`;
			}
		},
		data() {
			return {
				searchStr: "",
				activeNames: ["1"],
				is_simple: false, //是否是简版，控制手机号和症状显示
				searchDebounceTimer: null, // 搜索防抖定时器
				pageNo: 1,
				pageSize: 50,
				patientListTotal: 0,
				listLoading: false,
				pageLoadingDirection: '',
				activeStatus: "全部",
				localPatientList: null, // 本地患者列表数据（用于搜索时直接更新，null表示未初始化）
				statusList: [{
						name: "全部",
						id: 0
					},
					{
						name: "未完成",
						id: 1
					},
					{
						name: "已完成",
						id: 2
					}
				],
				statusList_select: [{
						name: "未完成",
						id: 1
					},
					{
						name: "已完成",
						id: 2
					}
				],
				// 患者统计信息
				patientSummary: {
					totalCount: 0,
					notVisitedCount: 0,
					visitedCount: 0
				},
				active: "",
				chatClassInput: "",
				isEdit: false, //编辑模式
				editItem: {},
				expandedCards: {}, // 存储展开状态的卡片ID
				allExpanded: {}, // 存储每个卡片的全部展开状态
				collapseActiveNames: {}, // 存储每个卡片的折叠面板激活状态
				selectedSortField: 'default', // 当前选择的排序字段
				isAscending: false, // 是否升序排列，默认为降序（desc）
				queryByDepartment: false,
				medicalRecordsData: {}, // 存储每个患者的病历记录数据
				testReportsData: {}, // 存储每个患者的检验报告数据
				// 临时测试：创建患者相关
				addPatientDialogVisible: false, // 创建患者弹窗显示状态
				addPatientLoading: false, // 创建患者提交中
				patientDepartmentList: [], //科室集合
				addPatientForm: {
					realname: '',
					age: '',
					phone: '',
					sex: '',
					departmentId: '',
				},
				addPatientFormRules: {
					realname: [{
							required: true,
							message: '姓名为必填',
							trigger: 'blur'
						},
						{
							pattern: /^[\u4e00-\u9fa5]{2,10}$/,
							message: '姓名应为2-10个中文字符',
							trigger: 'blur'
						}
					],
					sex: [{
							required: true,
							message: '性别为必填',
							trigger: 'blur'
						}
					],
					age: [{
						pattern: /^(?:0|[1-9]\d?|1[01]\d|120)$/,
						message: '年龄应为0-120的整数',
						trigger: 'blur'
					}],
					phone: [
						{
							pattern: /^1[3-9]\d{9}$/,
							message: '请输入正确的手机号',
							trigger: 'blur'
						}
					],
					departmentId: [
						{
							message: '请选择所属病房',
							trigger: 'blur'
						}
					]
				}
			};
		},
		methods: {
			getCurrentStatusItem() {
				return this.statusList.find(item => item.name === this.activeStatus) || {
					id: 0,
					name: '全部'
				};
			},
			getVisitStatusFromItem(item) {
				return item && item.id === 0 ? 0 : (item ? item.id : 0);
			},
			applyPatientListResult(result) {
				this.localPatientList = result.records || [];
				this.patientListTotal = result.total || 0;
				if (this.patientListTotal > 0 && this.pageNo > this.totalPages) {
					this.pageNo = this.totalPages;
				}
				const currentStatus = this.getCurrentStatusItem();
				this.$emit("statusBtn", {
					...currentStatus,
					patientList: this.localPatientList,
					total: this.patientListTotal
				});
			},
			async loadPatientList(options = {}) {
				const { resetPage = false, visitStatus } = options;
				if (resetPage) {
					this.pageNo = 1;
				}
				const statusItem = visitStatus !== undefined ?
					this.statusList.find(item => this.getVisitStatusFromItem(item) === visitStatus) || this.getCurrentStatusItem() :
					this.getCurrentStatusItem();
				const resolvedVisitStatus = visitStatus !== undefined ?
					visitStatus :
					this.getVisitStatusFromItem(statusItem);

				this.listLoading = true;
				try {
					const result = await this.getPatientList({
						visitStatus: resolvedVisitStatus
					});
					this.applyPatientListResult(result);
				} catch (error) {
					console.error('加载患者列表失败:', error);
				} finally {
					this.listLoading = false;
					this.pageLoadingDirection = '';
				}
			},
			async handlePrevPage() {
				if (!this.canPrevPage) {
					return;
				}
				this.pageLoadingDirection = 'prev';
				this.pageNo -= 1;
				await this.loadPatientList();
			},
			async handleNextPage() {
				if (!this.canNextPage) {
					return;
				}
				this.pageLoadingDirection = 'next';
				this.pageNo += 1;
				await this.loadPatientList();
			},
			async loadInitialPatientDepartmentList() {
				try {
					const userId = localStorage.getItem('userId');
					const result = await queryDepartmentListApi({"professionalId": userId});
					this.patientDepartmentList = Array.isArray(result) ? result : [];
				} catch (error) {
					this.patientDepartmentList = [];
				}
			},
			// 获取汉字拼音首字母
			getPinyinInitials(str) {
				if (!str) return '';
				const pinyinMap = {
					'张': 'z',
					'王': 'w',
					'李': 'l',
					'赵': 'z',
					'刘': 'l',
					'陈': 'c',
					'杨': 'y',
					'黄': 'h',
					'吴': 'w',
					'周': 'z',
					'徐': 'x',
					'孙': 's',
					'马': 'm',
					'朱': 'z',
					'胡': 'h',
					'郭': 'g',
					'林': 'l',
					'何': 'h',
					'高': 'g',
					'罗': 'l',
					'郑': 'z',
					'梁': 'l',
					'谢': 'x',
					'宋': 's',
					'唐': 't',
					'许': 'x',
					'邓': 'd',
					'冯': 'f',
					'韩': 'h',
					'曹': 'c',
					'曾': 'z',
					'彭': 'p',
					'萧': 'x',
					'蔡': 'c',
					'潘': 'p',
					'田': 't',
					'董': 'd',
					'袁': 'y',
					'于': 'y',
					'余': 'y',
					'叶': 'y',
					'蒋': 'j',
					'杜': 'd',
					'苏': 's',
					'魏': 'w',
					'程': 'c',
					'吕': 'l',
					'丁': 'd',
					'沈': 's',
					'任': 'r',
					'姚': 'y',
					'卢': 'l',
					'傅': 'f',
					'钟': 'z',
					'姜': 'j',
					'崔': 'c',
					'谭': 't',
					'廖': 'l',
					'范': 'f',
					'汪': 'w',
					'一': 'y',
					'二': 'e',
					'三': 's',
					'四': 's',
					'五': 'w',
					'六': 'l',
					'七': 'q',
					'八': 'b',
					'九': 'j',
					'十': 's',
					'明': 'm',
					'芳': 'f',
					'华': 'h',
					'军': 'j',
					'强': 'q',
					'敏': 'm',
					'静': 'j',
					'丽': 'l',
					'娟': 'j',
					'秀': 'x',
					'英': 'y',
					'伟': 'w',
					'杰': 'j',
					'涛': 't',
					'超': 'c',
					'勇': 'y',
					'磊': 'l',
					'鹏': 'p',
					'婷': 't',
					'红': 'h'
				};
				return str.split('').map(char => pinyinMap[char] || char).join('');
			},

			// 获取汉字拼音全拼（简易版）
			getFullPinyin(str) {
				if (!str) return '';
				const pinyinFullMap = {
					'张': 'zhang',
					'王': 'wang',
					'李': 'li',
					'赵': 'zhao',
					'刘': 'liu',
					'陈': 'chen',
					'杨': 'yang',
					'黄': 'huang',
					'吴': 'wu',
					'周': 'zhou',
					'徐': 'xu',
					'孙': 'sun',
					'马': 'ma',
					'朱': 'zhu',
					'胡': 'hu',
					'郭': 'guo',
					'林': 'lin',
					'何': 'he',
					'高': 'gao',
					'罗': 'luo',
					'郑': 'zheng',
					'梁': 'liang',
					'谢': 'xie',
					'宋': 'song',
					'唐': 'tang',
					'许': 'xu',
					'邓': 'deng',
					'冯': 'feng',
					'韩': 'han',
					'曹': 'cao',
					'曾': 'zeng',
					'彭': 'peng',
					'三': 'san',
					'四': 'si',
					'五': 'wu',
					'六': 'liu',
					'七': 'qi',
					'八': 'ba',
					'九': 'jiu',
					'十': 'shi',
					'明': 'ming',
					'芳': 'fang',
					'华': 'hua',
					'军': 'jun',
					'强': 'qiang',
					'敏': 'min',
					'静': 'jing',
					'丽': 'li'
				};
				return str.split('').map(char => pinyinFullMap[char] || char).join('');
			},

			// 简化显示按钮：只控制手机号和症状显示
			is_simpleBtn() {
				this.is_simple = !this.is_simple;
			},
			// 获取状态对应的人数
			getStatusCount(status) {
				if (status === '全部') {
					return this.patientSummary.totalCount;
				} else if (status === '未完成') {
					return this.patientSummary.notVisitedCount;
				} else if (status === '已完成') {
					return this.patientSummary.visitedCount;
				}
				return 0;
			},
			// 获取患者状态（用于光圈显示）
			getPatientStatus(patient) {
				// 根据就诊状态判断患者状态
				if (patient.visitStatus === 1) {
					return 'notVisited'; // 未完成，显示蓝色光圈
				} else if (patient.visitStatus === 2) {
					return 'visited'; // 已完成，显示绿色光圈
				}
				return 'normal'; // 正常状态，无光圈
			},
			async statusBtn(item) {
				this.activeStatus = item.name;
				await this.loadPatientList({
					resetPage: true,
					visitStatus: this.getVisitStatusFromItem(item)
				});
			},
			updateStatusBtn(item_status, item) {
				this.$emit("updateStatusBtn", item_status, item);
			},
			// 卡片点击：展开/收缩详细信息
			itemBtn(e, index, event) {
				// 检查点击的目标是否是折叠面板或其子元素
				if (event && event.target) {
					const target = event.target;
					const isCollapseArea = target.closest('.el-collapse') ||
						target.closest('.el-collapse-item') ||
						target.closest('.el-collapse-item__header') ||
						target.closest('.el-collapse-item__arrow') ||
						target.closest('.collapseTle') ||
						target.closest('.expandBox') ||
						target.closest('.btn') ||
						target.closest('button');

					// 如果点击的是折叠面板区域，不执行卡片展开/收缩逻辑
					if (isCollapseArea) {
						return;
					}
				}
				// 仅当切换到其他患者时才进行“结束会话”校验
				//const isSwitchingToAnother = this.active && e.id !== this.active;
				// if (isSwitchingToAnother && this.$parent && this.$parent.allowSwitchPatient) {
				//   const allow = this.$parent.allowSwitchPatient();
				//   if (allow === false) {
				//     this.$message.warning('请先结束当前会话，再切换到其他患者');
				//     return;
				//   }
				// }

				console.log("触发卡片点击");
				this.$emit("clickChatClass", e);

				if (this.active === e.id) {
					// 如果点击的是同一个卡片，切换展开状态
					this.$set(this.expandedCards, e.id, !this.expandedCards[e.id]);
				} else {
					// 如果点击的是新卡片，先收缩之前展开的卡片，然后展开新卡片
					// 清除所有展开状态
					this.expandedCards = {};
					this.allExpanded = {};
					this.collapseActiveNames = {};

					// 设置新的激活卡片并展开
					this.active = e.id;
					this.$set(this.expandedCards, e.id, true);

					// 加载患者的病历记录和检验报告数据（使用 username 查询，id 作为缓存键）
					this.loadPatientMedicalData(e.id, e.username, e.departmentId);
				}
				this.isEdit = false;
			},
			// 全部展开/收起按钮
			toggleAllExpanded(cardId) {
				this.$set(this.allExpanded, cardId, !this.allExpanded[cardId]);
			},
			// 通知父级展示病历详情
			emitViewMedicalDetail(recordId) {
				this.$emit('viewMedicalDetail', recordId);
			},
			// 获取当前激活的折叠面板项
			getActiveCollapseNames(cardId, type) {
				if (this.allExpanded[cardId]) {
					// 全部展开：返回所有项的ID
					if (type === 'medical') {
						return this.getMedicalRecordsFromCache(cardId).map(item => item.id);
					} else if (type === 'test') {
						return this.getTestReportsFromCache(cardId).map(item => item.id);
					}
				} else {
					// 返回当前激活的折叠项
					const key = `${cardId}_${type}`;
					return this.collapseActiveNames[key] || [];
				}
				return [];
			},
			// 处理折叠面板变化
			handleCollapseChange(activeNames, cardId, type) {
				if (!this.allExpanded[cardId]) {
					// 只有在非全部展开状态下才记录单独的展开状态
					const key = `${cardId}_${type}`;
					this.$set(this.collapseActiveNames, key, activeNames);
				}
			},
			// 排序切换
			async toggleSortOrder() {
				this.isAscending = !this.isAscending;
				await this.applySorting();
			},
			// 应用排序（直接重新调用患者列表接口）
			async applySorting() {
				await this.loadPatientList({ resetPage: true });
			},
			// 加载患者医疗数据（从后端获取真实数据）
			async loadPatientMedicalData(cacheKey, username, departmentId) {
				try {
					// 住院页面（dataOrigin='2'）时，不在这里调用 getMedicalRecords
					// 因为父组件会统一调用 loadLatestAdmissionDetail，避免重复调用接口
					if (this.dataOrigin !== '2') {
						// 获取病历记录（仅门诊页面）
						const medicalRecords = await this.getMedicalRecords(cacheKey);
						this.$set(this.medicalRecordsData, cacheKey, medicalRecords);
					}

					// 获取检验报告
					const testReports = await this.getTestReports(cacheKey, false, departmentId);
					this.$set(this.testReportsData, cacheKey, testReports);
				} catch (error) {
					console.error('加载患者医疗数据失败:', error);
				}
			},
			// 获取患者病历记录（新接口 /ly/archive/history）
			async getMedicalRecords(usernameOfPatient) {
				try {
					const userId = localStorage.getItem('userId');
					if (!userId) {
						console.error('未找到医生ID');
						return [];
					}
					// 从 classData 中查找对应的患者信息以获取 visitNum
					const patient = this.classData.find(p => p.id === usernameOfPatient || p.username ===
						usernameOfPatient);
					const visitNum = patient?.visitNum || patient?.visitNumber || localStorage.getItem('visitNum') ||
						'';
					const response = await request({
						url: '/ly/archive/history',
						method: 'POST',
						data: {
							medmstrId: usernameOfPatient,
							onlyMine: true,
							professionalId: userId,
							pageNum: 1,
							pageSize: 1,
							medicalSource: 1,
							visitNum: visitNum,
							dataOrigin: this.dataOrigin || ''
						}
					});
					if (response && response.success && Array.isArray(response.result)) {
						return response.result.map(item => ({
							id: item.id,
							date: item.visitDate,
							diagnosis: item.primaryDiagnosis,
							complaint: item.chiefComplaint,
							examination: item.physicalExamination,
							treatment: item.treatmentPlan
						}));
					}
					return [];
				} catch (error) {
					console.error('获取病历记录失败:', error);
					return [];
				}
			},
			// 获取患者检验报告（新接口 /ly/healthTestReports/testReports）
			async getTestReports(usernameOfPatient, includeChatId = false, departmentId = '') {
				try {
					const userId = localStorage.getItem('userId');
					if (!userId) {
						console.error('未找到医生ID');
						return [];
					}

					// 构建请求参数
					const requestData = {
						medmstrId: usernameOfPatient,
						professionalId: userId,
						pageNum: 1,
						pageSize: 1,
						dataOrigin: this.dataOrigin || ''
					};

					// 只有在明确需要包含 chatId 时才添加（比如刷新时）
					console.log("includeChatId:{},chatId:{}", includeChatId, this.currentChatId);
					if (includeChatId && this.currentChatId && this.currentChatId.trim() !== '') {
						requestData.chatId = this.currentChatId;
					}

					const response = await request({
						url: '/ly/healthTestReports/testReports',
						method: 'POST',
						data: {
							...requestData,
							departmentId: departmentId || ''
						}
					});
					if (response && response.success && Array.isArray(response.result)) {
						return response.result.map(item => ({
							id: item.externalReportId || item.id,
							name: item.testType,
							date: item.reviewTime,
							items: item.testItems,
							reference: item.normalRanges,
							result: item.results,
							summary: item.reportConclusion,
							image: item.reportFileUrl
						}));
					}
					return [];
				} catch (error) {
					console.error('获取检验报告失败:', error);
					return [];
				}
			},
			// 获取病历记录（从缓存中获取）
			getMedicalRecordsFromCache(patientId) {
				return this.medicalRecordsData[patientId] || [];
			},
			// 获取检验报告（从缓存中获取）
			getTestReportsFromCache(patientId) {
				return this.testReportsData[patientId] || [];
			},
			// 获取患者统计信息
			async getPatientSummary() {
				try {
					const userId = localStorage.getItem('userId');
					if (!userId) {
						console.error('未找到医生ID');
						return;
					}

					const response = await request({
						url: '/ly/patient/summary',
						method: 'GET',
						params: {
							professionalId: userId,
							dataOrigin: this.dataOrigin || '',
							queryByDepartment: this.queryByDepartment ? 1 : 0,
							keyword: this.searchStr,
						}
					});

					if (response && response.success) {
						this.patientSummary = response.result;
					} else {
						console.warn('获取患者统计信息失败，使用默认值');
						this.patientSummary = {
							totalCount: 0,
							notVisitedCount: 0,
							visitedCount: 0
						};
					}
				} catch (error) {
					console.error('获取患者统计信息失败:', error);
					// 设置默认值，避免界面显示异常
					this.patientSummary = {
						totalCount: 0,
						notVisitedCount: 0,
						visitedCount: 0
					};
				}
			},
			// 获取患者列表
			async getPatientList(params = {}) {
				try {
					const userId = localStorage.getItem('userId');
					if (!userId) {
						console.error('未找到医生ID');
						return {
							records: [],
							total: 0
						};
					}

					const requestParams = {
						pageNo: this.pageNo,
						pageSize: this.pageSize,
						keyword: this.searchStr || '',
						visitStatus: params.visitStatus || 0,
						professionalId: userId,
						sortField: this.selectedSortField,
						sortOrder: this.isAscending ? 'asc' : 'desc',
						...params,
						dataOrigin: this.dataOrigin || '',
						queryByDepartment: this.queryByDepartment ? 1 : 0
					};

					const response = await request({
						url: '/ly/patient/list',
						method: 'POST',
						data: requestParams
					});

					if (response && response.success && response.result) {
						return {
							records: response.result.records || [],
							total: response.result.total || 0
						};
					} else {
						console.warn('获取患者列表失败，返回空数组');
						return {
							records: [],
							total: 0
						};
					}
				} catch (error) {
					console.error('获取患者列表失败:', error);
					return {
						records: [],
						total: 0
					};
				}
			},
			async handleDeptScopeChange() {
				await this.getPatientSummary();
				await this.loadPatientList({ resetPage: true });
			},
			// 加载初始患者列表
			async loadInitialPatientList() {
				try {
					this.pageNo = 1;
					const currentStatus = this.getCurrentStatusItem();
					const result = await this.getPatientList({
						visitStatus: this.getVisitStatusFromItem(currentStatus)
					});
					this.applyPatientListResult(result);
				} catch (error) {
					console.error('加载初始患者列表失败:', error);
				}
			},
			// 刷新病历记录
			async refreshMedicalRecords(patientId, username) {
				try {
					const data = await this.getMedicalRecords(patientId);
					this.$set(this.medicalRecordsData, patientId, data);
					this.$message.success('病历记录已刷新');
				} catch (error) {
					this.$message.error('刷新病历记录失败');
				}
			},
			// 刷新检验报告
			async refreshTestReports(patientId, username, departmentId) {
				try {
					const data = await this.getTestReports(patientId, true,
						departmentId); // 刷新时传入 includeChatId = true
					this.$set(this.testReportsData, patientId, data);
					this.$message.success('检验报告已刷新');
				} catch (error) {
					this.$message.error('刷新检验报告失败');
				}
			},
			createChatBox() {
				this.$emit("createChatBox");
				this.isEdit = false;
				this.isEdit = false;
				this.active = "";
			},
			blurBtn(e) {
				this.$emit("editChatClass", this.editItem, this.chatClassInput);
				this.isEdit = false;
				this.editItem = {};
			},
			editChatClass(e) {
				console.log(e);
				this.isEdit = true;
				this.chatClassInput = e.title;
				this.editItem = e;
			},
			clickInput(e) {
				console.log(e);
			},
			deleteChatClass(e) {
				console.log(e);
				this.$emit("deleteChatClass", e);
			},
			async refreshData() {
				await this.getPatientSummary();
				await this.loadPatientList();
				this.$emit("refreshData");
			},
			joinChat(item) {
				this.$emit("joinChat", item);
			},
			// 临时测试：显示创建患者弹窗
			showAddPatientDialog() {
				this.addPatientDialogVisible = true;
			},
			// 临时测试：重置创建患者表单
			resetAddPatientForm() {
				this.$refs.addPatientForm && this.$refs.addPatientForm.resetFields();
				this.addPatientForm = {
					realname: '',
					age: '',
					phone: ''
				};
			},
			// 临时测试：创建患者
			async handleAddPatient() {
				this.$refs.addPatientForm.validate(async (valid) => {
					if (!valid) {
						return false;
					}

					// 校验年龄
					if (this.addPatientForm.age && !/^\d{1,3}$/.test(this.addPatientForm.age)) {
						this.$message.error('年龄应是1-3位数字');
						return false;
					}

					// 校验手机号
					if (this.addPatientForm.phone && !/^\d{11}$/.test(this.addPatientForm.phone)) {
						this.$message.error('手机应是11位数字');
						return false;
					}

					this.addPatientLoading = true;
					try {
						const userId = localStorage.getItem('userId');
						if (!userId) {
							this.$message.error('未找到医生ID');
							return;
						}

						// 获取科室ID和租户ID（从localStorage或props，如果都没有则使用默认值）
						//const departmentId = '647b1a61b4284cd95fe6200c7fda0361';
						const tenantId = localStorage.getItem('loginTenantId') || '';

						if (!this.addPatientForm.departmentId || !tenantId) {
							this.$message.warning('科室ID或租户ID未配置，使用默认值');
						}

						const requestData = {
							realname: this.addPatientForm.realname,
							age: this.addPatientForm.age || undefined,
							sex: this.addPatientForm.sex || undefined,
							phone: this.addPatientForm.phone || undefined,
							professionalId: userId,
							departmentId: this.addPatientForm.departmentId || 'default',
							tenantId: tenantId || 'default',
							forceUpdate: false
						};

						// 如果是从住院入口进入（dataOrigin === '2'），需要带上 dataOrigin=2；
						// 门诊入口则不加该字段，保持接口兼容旧逻辑
						if (String(this.dataOrigin) === '2') {
							requestData.dataOrigin = 2;
						}

						const response = await request({
							url: '/ly/patient/add',
							method: 'POST',
							data: requestData
						});

						// 优先处理重复提示（409错误）
						if (response && response.code === 409 && response.result && response.result
							.duplicate) {
							// 直接显示确认框，不显示错误消息
							this.$nextTick(() => {
								this.$confirm('姓名重复, 是否仍要创建？', '提示', {
									confirmButtonText: '创建',
									cancelButtonText: '返回',
									type: 'warning',
									customClass: 'duplicate-confirm-dialog'
								}).then(async () => {
									// 用户确认创建，使用forceUpdate=true重新提交
									requestData.forceUpdate = true;
									const retryResponse = await request({
										url: '/ly/patient/add',
										method: 'POST',
										data: requestData
									});
									if (retryResponse && retryResponse.success) {
										this.$message.success('添加患者成功');
										this.addPatientDialogVisible = false;
										this.resetAddPatientForm();
										await this.refreshData();
									} else {
										this.$message.error(retryResponse?.message ||
											'添加患者失败');
									}
								}).catch(() => {
									// 用户取消，不做任何操作
								});
							});
							return;
						}

						if (response && response.success) {
							this.$message.success('添加患者成功');
							this.addPatientDialogVisible = false;
							this.resetAddPatientForm();
							// 刷新患者列表
							await this.refreshData();
						} else {
							this.$message.error(response?.message || '添加患者失败');
						}
					} catch (error) {
						console.error('创建患者失败:', error);
						this.$message.error('创建患者失败：' + (error.message || '未知错误'));
					} finally {
						this.addPatientLoading = false;
					}
				});
			}
		}
	};
</script>

<style scoped lang="less">
</style>

<style lang="less">
	/* 非scoped样式 - 强制应用搜索框圆角 */
	.chatClass .search .el-input__inner {
		border-radius: 30px !important;
		background: rgb(242, 242, 247) !important;
	}

	.chatClass .search .el-input--prefix .el-input__inner {
		border-radius: 30px !important;
	}
</style>

<style>
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	::-webkit-scrollbar-thumb:hover {
		background: #a8a8a8;
	}

	::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 3px;
	}

	::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	.icon-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		color: #4169e1;
		/* 蓝色 */
		border: none;
		background: none;
		padding: 0.5rem;
		cursor: pointer;
	}

	.icon-img {
		width: 1.2rem;
		height: 1.2rem;
		display: block;
	}

	/*
 * 切勿在此设置全局 .v-modal 的 z-index。
 * Element UI 的 PopupManager 会为每个遮罩设置内联 z-index；若用 !important
 * 抬高所有 .v-modal，会导致遮罩盖在 el-dialog（如 z-index=3000）之上，全站弹窗无法操作。
 * 重复患者确认框依赖 PopupManager 顺序即可；添加患者弹窗已 :modal="false"。
 */
</style>


<style lang="less" src="./index.less"></style>